import { useTranslation } from '../../i18n';

interface Props {
  /** ISO date `YYYY-MM-DD`. */
  date?: string;
}

/**
 * Renders a small "Last updated: YYYY-MM-DD" stamp under the article title.
 * Reads the date from a prop (sourced from frontmatter); if missing, renders
 * nothing.
 */
export default function LastUpdated({ date }: Props) {
  const t = useTranslation();
  if (!date) return null;
  return (
    <p className="docs-last-updated">
      <span>{t('page.lastUpdated') ?? 'Last updated'}: <time dateTime={date}>{date}</time></span>
      <style>{css}</style>
    </p>
  );
}

const css = `
.docs-last-updated {
  margin: 4px 0 24px;
  font-size: 0.82em;
  color: var(--c-muted);
  font-style: italic;
}
.docs-last-updated time {
  font-family: var(--font-mono);
  font-style: normal;
}
`;
